export default {
  slug: "dotnet-tools",
  code: "DNT",
  label: "dotNet Tools",
  shortLabel: ".NET Tools",
  altLabel: ".NET Tools",
  isDotNet: true,
  logoFamily: "jb",
};
